import axios, { CancelTokenSource } from 'axios';
import { useContext, useRef } from 'react';
import useSWR from 'swr';
import {
  AXIOS_CANCEL_MSG, NotificationEvent, Page, QuoteFilter
} from '../api/models';
import { ConfiguratorContext } from '../context';
import {SorterResult} from "antd/lib/table/interface";

type  SortResult<T> = SorterResult<T> | SorterResult<T>[]

interface NotificationEventProps {
  filter?: QuoteFilter
  current?: number
  pageSize?:number,
  sorter?:SortResult<NotificationEvent>
}

export const useNotificationEvents = (props?: NotificationEventProps) => {

  const cancelTokenSourceRef = useRef<CancelTokenSource>();
  const configurator = useContext(ConfiguratorContext);

  const fetcher = async ( props?:NotificationEventProps  ) : Promise<Page<NotificationEvent> | undefined> => {

    //const { quoteId, revision } = props;
    //if (!revision) return;

    if ( cancelTokenSourceRef.current ) {
      cancelTokenSourceRef.current.cancel( AXIOS_CANCEL_MSG );
    }
    const cancelSource = axios.CancelToken.source();
    cancelTokenSourceRef.current = cancelSource;

    try {
      const resp = await configurator.api.fetchNotificationEvents(cancelSource.token);
      cancelTokenSourceRef.current = undefined;

      return resp.data
    }
    catch(e: any) {
      const id = e.response?.data?.message || e.message ;
      if ( id === AXIOS_CANCEL_MSG ) return;
      throw e;
    }
  };

  // Use SWR for data fetching
  return useSWR([
        'fetchNotificationEvents',
        props
      ],
      ([_k, p]) => fetcher(p),
      {
        dedupingInterval:1
      }
  );
};


export default useNotificationEvents;

